import React from 'react'
import './Icon.css'

export interface IconProps {
  src: string
  alt?: string
  size?: number
  className?: string
}

export const Icon: React.FC<IconProps> = ({
  src,
  alt = '',
  size = 24,
  className = '',
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`icon ${className}`}
      style={{ width: size, height: size }}
    />
  )
}
